import { NUMBER, INTEGER } from '@/plugins/sdk/fields'
import isFinite from 'lodash/isFinite'

export default {
  label: 'Does not equal',
  operator: 'does not equal',
  fields: [ NUMBER, INTEGER ],
  isValidValue (value) {
    return isFinite(value)
  }
}
